import React from 'react';
import {Link} from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

//import LoginPage from './LoginPage.js'
//import {resourceEndpoint} from './config';
//import {useTranslation} from 'react-i18next'

function NavBar(props) {
  
  return (
    <Navbar expand="lg" fixed="top" className="navbar" style={{zIndex: "2", paddingTop: "0px", paddingBottom: "0px"}}>
      <Nav>
        <Link className="nav-link" to="/">{props.title}</Link>
      </Nav>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
      <Nav>
      {props?.navBarItems ? 
      Object.entries(props.navBarItems).map(([name, url],idx) => {
        return <Link key={idx + "-" + url} className="nav-link" to={"/text?resourceid=" + url}>{name}</Link>
      })
      :
       <>
        <Link className="nav-link" to={"/text?resourceid=" + props.entryResource}>Texts</Link>
        <Link className="nav-link" to="/about">About</Link>
         <span className="nav-link">News</span>
         </>
      }
      </Nav>
      <Nav>
        {
          //<span className="nav-link" to="/about">{t("About")}</span>
        }
        <a className="nav-link" href="https://secure.qgiv.com/for/givescta">Donate</a>
      </Nav>
      
      </Navbar.Collapse>
      <Navbar.Collapse id="basic-navbar-nav-right" className="float-right" style={{flexGrow: "0"}}>
      {/* <Nav>
          <LoginPage user={props.user}/>
      </Nav> */}
      </Navbar.Collapse>
      

      
      
    </Navbar>

  );
}

export default NavBar;
